<template>
  <v-card flat>
    <portal to="building-toolbar-title-after"> <v-icon>mdi-arrow-right</v-icon> {{projectDetails.ProjectName}}</portal>
    <v-tabs background-color="grey lighten-5" @change="onTabChange">
      <v-tab>
        ΣΤΟΙΧΕΙΑ ΑΝΥΨΩΤΙΚΟΥ
      </v-tab>
      <v-tab>
        ΙΣΤΟΡΙΚΟ ΓΕΓΟΝΟΤΩΝ
      </v-tab>
      <v-tab-item class="pa-4">
        <div>
          <v-card>
            <v-card-title>
              Συντήρηση
            </v-card-title>
            <v-card-text>
              Συχνότητα συντήρησης
              <v-simple-table dense fixed-header>
                <template v-slot:default>
                  <thead>
                  <tr>
                    <th class="text-left">Ιαν</th>
                    <th class="text-left">Φεβ</th>
                    <th class="text-left">Μαρ</th>
                    <th class="text-left">Απρ</th>
                    <th class="text-left">Μάης</th>
                    <th class="text-left">Ιουν</th>
                    <th class="text-left">Ιουλ</th>
                    <th class="text-left">Αυγ</th>
                    <th class="text-left">Σεπτ</th>
                    <th class="text-left">Οκτ</th>
                    <th class="text-left">Φλεβ</th>
                    <th class="text-left">Δεκ</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr>
                    <td v-for="month in projectDetails.SixnotitaSintirisis">
                      <v-icon small v-if="month">mdi-check-circle</v-icon>
                    </td>
                  </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card-text>

            <v-list>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>{{ projectDetails.LastSint | fullDate }}</v-list-item-title>
                  <v-list-item-subtitle> Τελευταία συντήρηση</v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-content>
                  <v-list-item-title>{{ projectDetails.EktHmerSint | fullDate }}</v-list-item-title>
                  <v-list-item-subtitle> Επόμενη συντήρηση (εκτίμιση)</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card>
          <v-card class="mt-4">
            <v-card-title> Τεχνικά Χαρακτηριστικά</v-card-title>
            <v-card-text>
              <v-data-iterator
                  :group-by="['SpecDescr']"
                  :items="projectDetails.Specifications"
                  hide-default-footer
                  disable-pagination
                  no-data-text="Δεν υπάρχουν τεχνικά χαρακτηριστικά διαθέσιμα"
              >
                <template v-slot:default="props">
                  <template>
                    <v-expansion-panels flat multiple :value="[0 ]">
                      <v-expansion-panel v-for="group in props.groupedItems">
                        <v-expansion-panel-header class="pa-0 grey lighten-3">
                          <v-list-item dense>
                            <v-list-item-content>
                              <v-list-item-title class="text--black">
                                {{ group.name }}
                              </v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content eager>
                          <v-list>
                            <v-list-item class="pa-0" v-for="item in group.items">
                              <v-list-item-content>
                                <v-list-item-title> {{ item.SpecItemValue }}</v-list-item-title>
                                <v-list-item-subtitle> {{ item.SpecItemDescr }}</v-list-item-subtitle>
                              </v-list-item-content>
                            </v-list-item>
                          </v-list>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>

                  </template>

                </template>
              </v-data-iterator>
            </v-card-text>
          </v-card>

        </div>
      </v-tab-item>
      <v-tab-item class="pa-4">
        <v-card style="width: 100%">
          <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
            <v-card class="background">
              <event-card v-if="activeEvent" :key="activeEvent.Event_ID" :event-id="activeEvent.Event_ID">
                <template v-slot:beforeTitle>
                  <v-btn icon @click="dialog = false">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </template>
              </event-card>
            </v-card>
          </v-dialog>
          <v-list v-if="isMobile">
            <event-mobile-item @click="rowClick(e)" v-for="e in projectEvents" :item="e"></event-mobile-item>
          </v-list>
          <v-data-table v-if="!isMobile" @click:row="rowClick" :headers="headers" :items="projectEvents" disable-pagination
                        hide-default-footer fixed-header height="600px" :mobile-breakpoint="0">
            <template v-slot:item.DateEventInsert="{item}">
              <span v-if="item.EventType_ID === 1">{{ item.DateStart | fullDate }}</span>
              <span v-else> {{ item.DateEventInsert | fullDate }}</span>
            </template>
            <template v-slot:item.EventType_ID="{item}">
              <v-chip outlined v-if="item.EventType_ID === 1" color="maintenance"> Συντήρηση</v-chip>
              <v-chip outlined v-else-if="item.EventType_ID === 2" color="callout" dark> Βλάβη
              </v-chip>
              <v-chip outlined v-else-if="item.EventType_ID === 3" color="task" dark> Άλλη εργασία
              </v-chip>
            </template>
          </v-data-table>
        </v-card>

      </v-tab-item>
    </v-tabs>
  </v-card>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import EventCard from "../../Events/components/EventCard";
import EventMobileItem from "@/views/Events/components/EventMobileItem";

export default {
  name: "ProjectCard",
  components: {EventMobileItem, EventCard},
  data: () => ({
    dialog: false,
    activeEvent: null,
    headers: [
      {
        text: 'Hμ/νια ',
        value: 'DateEventInsert',
        filterable: true,
        width: "100"
      },
      {
        text: 'Tύπος',
        value: 'EventType_ID',
        filterable: true,
        width: "100"
      },
      {
        text: 'Περιγραφή',
        value: 'Description',
        filterable: true,
      },
    ]
  }),

  computed: {
    ...mapGetters([
      "isMobile"
    ]),
    ...mapGetters('project', [
      "projectDetails",
      "projectEvents",
    ]),

  },

  methods: {
    ...mapActions('project', [
      "getProjectEvents"
    ]),
    rowClick(event) {
      if (!this.isMobile) {
        this.$modal.show(EventCard, {eventId: event.Event_ID}, {height: 'auto', width: '70%'});
      } else {
        this.dialog = true;
        this.activeEvent = event
      }
    },
    onTabChange(tabIndex) {
      if (tabIndex === 1) {
        this.getProjectEvents();
      }
    }
  }
}
</script>

<style scoped>

</style>
